import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import { LicenseInfo } from '@mui/x-license-pro';
import { App } from './modules/App';
import reportWebVitals from './reportWebVitals';
import 'typeface-poppins';

LicenseInfo.setLicenseKey(
  '5222418aa23dd79b6d4843a6cf5ff023Tz00ODY0NixFPTE2OTEzNTQ4ODE4ODQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

window.version = '0.0.0';

window.addEventListener('load', () => {
  const versionMeta: HTMLMetaElement | null = window.document.querySelector(
    'meta[name="version"]'
  );
  window.version = versionMeta?.content || window.version;
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
